import React from "react"
import ReactDOM from "react-dom"
import 'bootstrap/dist/css/bootstrap.min.css';
import "./styles/styles.css"
import AppRouter from "./components/AppRouter"

ReactDOM.render(<AppRouter />, document.getElementById("root"))